import script from "./EditChatMobileGroupChat.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditChatMobileGroupChat.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__